module.exports = __webpack_public_path__ + "img/znspImg@2x.5451e86a.png";